import { ReactNode, useState, createContext, useContext } from "react";
import { Sidebar, UserRole } from "./Sidebar";
import { Header } from "./Header";
import { cn } from "@/lib/utils";

interface SidebarContextValue {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const SidebarContext = createContext<SidebarContextValue | null>(null);

// eslint-disable-next-line react-refresh/only-export-components
export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within AppLayout");
  }
  return context;
}

interface AppLayoutProps {
  children: ReactNode;
  userRole?: UserRole;
}

export function AppLayout({ children, userRole = "applicant" }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      <div className="min-h-screen bg-[#FAFAFA]">
        <Sidebar userRole={userRole} collapsed={collapsed} />
        
        <div
          className={cn(
            "min-h-screen flex flex-col transition-all duration-200",
            collapsed ? "pl-16" : "pl-60"
          )}
        >
          <Header />
          
          <main className="flex-1 px-4 py-6">
            {children}
          </main>
        </div>
      </div>
    </SidebarContext.Provider>
  );
}
